import { Province } from './../../provinces/province';
import { Component, OnInit, ViewChild, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { LoyaltySiteManagementFieldService } from './loyalty-site-management-field.service';
import { LoyaltySite } from "./loyalty-site";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { LoyaltySiteManagementService } from "./loyalty-site-management.service";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { AppState } from "../../../app.service";
import { AlertService } from "../../../services/index";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { DynamicFormComponent } from "../../dynamic-form/dynamic-form.component";
import { Panel } from '../../../Panel/panel';
import { PermissionService } from "../../../services/SecurityServices/permission.service";
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { HttpClient } from "@angular/common/http";
import { PasswordControl } from '../../dynamic-form/password-control';
import { DropdownControl } from "../../dynamic-form/dropdown-control";

@Component({
    template: require('./loyalty-site-management.html'),
    providers: [LoyaltySiteManagementFieldService, LoyaltySiteManagementService, Modal],
    styles: [require('../dynamic-form.css'), require('./integration.css')]
})

export class LoyaltySiteManagementComponent implements OnInit {

    public fields: FormControlBase<any>[] = null;
    public disableForm: boolean = false;
    public showSiteIntegration: boolean = false;
    public loyaltySite: LoyaltySite;
    public initialId: string;
    public canGenerateLocationId: boolean = false;
    public canGenerateUsername: boolean = false;
    public canGeneratePassword: boolean = false;
    public hasExistingPassword: boolean = false;
    public auditFilter: string = "Sites";
    private busy: Subscription;
    private tabIndex = 0;
    private tabs: Array<any> = [
        { active: true, label: 'Create/Update' }
    ];
    private provinces: Province[];
    private optionSelected: {id: string, value: string, selectedIndex: string};

    @ViewChild('loyaltySiteForm') loyaltySiteFormComponent: DynamicFormComponent;

    constructor(
        private appState: AppState,
        private alertService: AlertService,
        private formControlService: LoyaltySiteManagementFieldService,
        private route: ActivatedRoute,
        private loyaltySiteManagementService: LoyaltySiteManagementService,
        private router: Router,
        private permissionService: PermissionService,
        public modal: Modal,
        vcRef: ViewContainerRef,
        private http: HttpClient
    ) {
        this.modal.overlay.defaultViewContainer = vcRef;
    }

    private setTab(selectedTab: any): void {
        for (let tab of this.tabs) {
            tab.active = false;
        }
        selectedTab.active = true;
        this.tabIndex = this.tabs.indexOf(selectedTab);
    }

    private revertForm(): void {
        this.loyaltySiteFormComponent.form.patchValue(this.loyaltySite);
    }

    private submitForm(): void {
        let copy: any = Object.assign({
            loyaltySiteId: this.loyaltySite.LoyaltySiteId
        }, this.loyaltySiteFormComponent.form.value);

        if (copy.password && copy.confirmPassword && copy.password != copy.confirmPassword) {
            this.alertService.error('Password and Confirm Password does not match.');
            return;
        }

        copy.status = copy.status ? 2 : 1;
        let self: LoyaltySiteManagementComponent = this;
        if (this.initialId == 'new') {
            this.http.post<any>(LoyaltySiteManagementService.loyaltySiteUrl, copy).subscribe(() => {
                self.router.navigate(['admin/loyalty-site-management']);
            });
            return;
        }
        this.http.put<any>(LoyaltySiteManagementService.loyaltySiteUrl, copy).subscribe(() => {
            self.router.navigate(['admin/loyalty-site-management']);
        });
    }

    private getNewLocationID() {
        let self: LoyaltySiteManagementComponent = this;
        this.loyaltySiteManagementService.getNextLocationId()
            .map((locationId: string) => {
                if (!locationId) {
                    return locationId;
                }
                return this.stripDoubleQuotes(locationId);
            })
            .subscribe((locationId: string) => {
                self.loyaltySiteFormComponent.form.patchValue({ 'siteId': locationId });
            });
    }

    private stripDoubleQuotes(string: string): string {
        if (string[0] == "\"" && string[string.length - 1] == "\"") {
            return string.substring(1, string.length - 1);
        } else {
            return string;
        }
    }

    showExistingPassword(){
        this.modal.alert()
                    .title('Existing Password')
                    .body(this.loyaltySite.plainTextPassword)
                    .open();
    }

    private getNewPassword() {
        let self: LoyaltySiteManagementComponent = this;
        this.loyaltySiteManagementService.getNewPassword()
            .map((password: string) => {
                if (!password) {
                    return password;
                }
                return this.stripDoubleQuotes(password);
            })
            .subscribe((password: string) => {
                self.loyaltySiteFormComponent.form.patchValue({ 'password': password });
                self.loyaltySiteFormComponent.form.patchValue({ 'confirmPassword': password });

                this.modal.alert()
                    .title('New Password Created - Copy this now')
                    .body(this.loyaltySiteFormComponent.form.value.password)
                    .open();

            });
    }


    private conditionalNull(obj, key): any {
        return key.split(".").reduce(function (o, x) {
            return (typeof o == "undefined" || o === null) ? o : o[x];
        }, obj);
    }

    private getNewUserName() {
        let self: LoyaltySiteManagementComponent = this;
        var formSiteId = this.loyaltySiteFormComponent.form.value.siteId;
        this.loyaltySiteManagementService.getNextUsername(formSiteId)
            .map((username: string) => {
                if (!username) {
                    return username;
                }
                return this.stripDoubleQuotes(username);
            })
            .subscribe((username: string) => {
                self.loyaltySiteFormComponent.form.patchValue({ 'userName': username });
            });
    }



    private modifyFormControls(self: LoyaltySiteManagementComponent) {
        let passwordControl = self.fields.find((control: FormControlBase<any>) => control.key == 'password');
        passwordControl.required = false;
        passwordControl.label = 'New Password (Optional)';
        let confirmPasswordControl = self.fields.find((control: FormControlBase<any>) => control.key == 'confirmPassword');
        confirmPasswordControl.required = false;
    }

    ngOnInit() {

        let self: LoyaltySiteManagementComponent = this;
        this.route.paramMap
            .switchMap((params: ParamMap) => {
                self.initialId = params.get('id');
                let observable = self.loyaltySiteManagementService.getLoyaltySite(params.get('id'));
                self.busy = observable.subscribe();
                return observable;
            })
            .subscribe((loyaltySite: LoyaltySite) => {
                self.loyaltySite = loyaltySite;
                self.disableForm = !self.permissionService.userHasPermission(self.initialId == 'new' ? 'Site_PostSite' : 'Site_UpdateSite');
                self.fields = self.formControlService.getFields();
                this.setLocationGroupFieldOptions();
                this.setProvinceFieldOptions();
                self.setPasswordFieldOptions();
                setTimeout((self, loyaltySite) => {
                    self.loyaltySiteFormComponent.form.patchValue(loyaltySite)
                    self.canGenerateLocationId = self.initialId == 'new' && !self.loyaltySiteFormComponent.form.value.siteId;
                    self.canGenerateUsername = self.initialId == 'new' && !self.loyaltySiteFormComponent.form.value.userName;
                    self.canGeneratePassword = self.initialId == 'new' && !self.loyaltySiteFormComponent.form.value.password;
                    self.hasExistingPassword = !!loyaltySite.plainTextPassword;
                }, 50, self, loyaltySite);
                if (self.initialId !== 'new') {
                    self.modifyFormControls(self);
                }
            });


    }

    private setPasswordFieldOptions(): void {
        if (this.initialId !== 'new')
            return;
        let passwordField = this.fields.find(x => x.key == 'password') as PasswordControl;
        passwordField.required = true;
        let confirmPasswordField = this.fields.find(x => x.key == 'confirmPassword') as PasswordControl;
        confirmPasswordField.required = true;
    }

    private setProvinceFieldOptions(): void {
        /*let provinceField = this.fields.find(x => x.key == 'provinceID') as DropdownControl;
        this.loyaltySiteManagementService.getAllProvinces().subscribe(data => {
            provinceField.options = data.map(prov => {
                console.log(prov);
                return { key: prov.ProvinceID, value: prov.Description };
            });
            this.loyaltySiteFormComponent.form.patchValue({ 'province': provinceField });
        });*/

        let provinceField = this.fields.find(x => x.key == 'provinceID') as DropdownControl;
        this.loyaltySiteManagementService.getProvinces().subscribe(data => {
            console.log(data);
            let objData = JSON.parse(data);
            this.provinces = objData.provinces;
            let countryProvinces = this.provinces.filter(function(cProv) {
                return cProv.country == "South Africa";
              });

            provinceField.options = countryProvinces.map(prov => {
                console.log(prov);
                return { key: prov.provinceID.toString(), value: prov.description };
            });
            this.loyaltySiteFormComponent.form.patchValue({ 'province': provinceField });
        });
    }

    private setLocationGroupFieldOptions(): void {
        let locationGroupField = this.fields.find(x => x.key == 'LocationGroupID') as DropdownControl;
        this.loyaltySiteManagementService.getAllLocationGroups().subscribe(data => {
            locationGroupField.options = data.map(locGroup => {
                console.log(locGroup);
                return { key: locGroup.LocationGroupID, value: locGroup.Description };
            });
            this.loyaltySiteFormComponent.form.patchValue({ 'locationGroup': locationGroupField });
        });
    }

    private setCountryProvinceFieldOptions(country: string): void {
        let provinceField = this.fields.find(x => x.key == 'provinceID') as DropdownControl;
        let countryProvinces = this.provinces.filter(function(cProv) {
            return cProv.country == country;
          });

        provinceField.options = countryProvinces.map(prov => {
            console.log(prov);
            return { key: prov.provinceID.toString(), value: prov.description };
        });
        this.loyaltySiteFormComponent.form.patchValue({ 'province': provinceField });
    }

    private selectedValueChanged(selectedValue: {id: string, value: string, selectedIndex: string}){
        this.optionSelected = selectedValue;
        console.log(`${this.optionSelected.id} | ${this.optionSelected.value} | ${this.optionSelected.selectedIndex}`);

        if(this.optionSelected.id == "country"){
            this.setCountryProvinceFieldOptions(this.optionSelected.value);
            console.log(this.optionSelected.value);
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/loyalty-site/loyalty-site-management.component.ts